import {
  collection,
  getDocs,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore';
import { firestore } from '../config/firebase';

const COLLECTION = 'fundInvestorPeriodAllocations';

/**
 * Subscribe to allocations for a given fundInvestor.
 * @param {string} fundInvestorId
 * @param {{ limit?: number }} [opts]
 * @param {(items: Array<object>) => void} callback
 * @returns {() => void}
 */
export function subscribeAllocationsByFundInvestor(fundInvestorId, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  if (!fundInvestorId) {
    callback?.([]);
    return () => {};
  }
  const lim = Number(opts?.limit) > 0 ? Number(opts.limit) : 24;
  const q = query(
    collection(firestore, COLLECTION),
    where('fundInvestorId', '==', fundInvestorId)
  );
  return onSnapshot(
    q,
    (snap) => {
      const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      items.sort((a, b) => String(b.periodKey || '').localeCompare(String(a.periodKey || '')));
      callback(items.slice(0, lim));
    },
    (err) => {
      console.warn('[fundInvestorPeriodAllocations] snapshot error:', err?.code, err?.message);
      callback([]);
    }
  );
}

/**
 * One-time fetch of allocations for a fundInvestor (sorted desc by periodKey client-side).
 * @param {string} fundInvestorId
 * @param {{ limit?: number }} [opts]
 * @returns {Promise<Array<object>>}
 */
export async function getAllocationsByFundInvestorOnce(fundInvestorId, opts = {}) {
  if (!fundInvestorId) return [];
  const lim = Number(opts?.limit) > 0 ? Number(opts.limit) : 24;
  const q = query(
    collection(firestore, COLLECTION),
    where('fundInvestorId', '==', fundInvestorId)
  );
  const snap = await getDocs(q);
  const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  items.sort((a, b) => String(b.periodKey || '').localeCompare(String(a.periodKey || '')));
  return items.slice(0, lim);
}

